import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import Card from './card'
import { useDispatch, useSelector } from "react-redux";
import { actionTypes as actionTypesPost } from './../../../../../redux/post/selectPost';

let useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        margin: 'auto',
        minHeight: 350,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        marginTop: 50,
        [theme.breakpoints.down('1500')]: {
            width: '90%',
        },
        [theme.breakpoints.down('1250')]: {
            // width: '95%',
        },
        // [theme.breakpoints.down(responsiveLength)]: {
        //     minHeight: 525,
        // },
        [theme.breakpoints.down('500')]: {
            width: '97%',
            justifyContent: 'center',
        }
    },
}))

export default function Index() {

    let classes = useStyles();
    let dispatch = useDispatch();
    let size = 3;

    const [statePost, setStatePost] = useState({});

    let stateReducer = useSelector(state => state.select_post_reducer)

    let apiSubmitPost = () => {

        dispatch({ type: actionTypesPost?.postSelectAsync, payload: { id: 168 } })
        dispatch({ type: actionTypesPost?.postSelectAsync, payload: { id: 134 } })
        dispatch({ type: actionTypesPost?.postSelectAsync, payload: { id: 140 } })
    }

    useEffect(() => {
        apiSubmitPost()
    }, []);


    useEffect(() => {

        let obj = {}
        if (Object.keys(stateReducer?.data)?.length > 0) {
            let data = stateReducer?.data
            setStatePost(data)

            let a = Object.keys(stateReducer?.data)
            .forEach((item, index) => {
                if (!obj[item]) {
                    let imagesListRequest = stateReducer?.data[item]
                    let b = Object.keys(imagesListRequest)?.reverse()
                        ?.filter((item, index) => index <= size)
                        ?.forEach((idImages) => {
                            dispatch({ type: actionTypesPost?.mediaSelectAsync, payload: { id: idImages } })
                        })
                }
            })

            obj = data
        }

    }, [stateReducer?.data]);



    return (
        <div className={classes['root']}>


            <Card
                loading={stateReducer?.loading[134]}
                images={stateReducer?.images}
                data={
                    {
                        title: 'جدید‌ترین مطالب تحلیلی',
                        list: statePost['134'] ? statePost['134'] : {},
                        linkCategory: 'https://mag.pouyanbroker.com/analysis/',
                    }
                }
                size={size}
            />
            <Card
                loading={stateReducer?.loading[140]}
                images={stateReducer?.images}
                data={
                    {
                        title: 'جدیدترین مقالات آموزشی',
                        list: statePost['140'] ? statePost['140'] : {},
                        linkCategory: 'https://mag.pouyanbroker.com/education/',
                    }
                }
                size={size}
            />
            <Card
                loading={stateReducer?.loading[168]}
                images={stateReducer?.images}
                data={
                    {
                        title: 'آخرین اخبار',
                        list: statePost['168'] ? statePost['168'] : {},
                        linkCategory: 'https://mag.pouyanbroker.com/news/',
                    }
                }
                size={size}
            />

        </div>)
}


let data = {
    tahlil: {
        title: 'جدید‌ترین مطالب تحلیلی',
        list: [
            {
                title: 'سهام عدالت متوفیان الکترونیکی',
                date: '9 آبان 1402',
                image: 'assets/images/news/image 14.png'
            },
            {
                title: 'سهام عدالت متوفیان الکترونیکی',
                date: '9 آبان 1402',
                image: 'assets/images/news/image 15.png'
            },
            {
                title: 'سهام عدالت متوفیان الکترونیکی',
                date: '9 آبان 1402',
                image: 'assets/images/news/image 16.png'
            },
        ]
    },
    edu: {
        title: 'جدیدترین مقالات آموزشی',
        list: [
            {
                title: 'سهام عدالت متوفیان الکترونیکی',
                date: '9 آبان 1402',
                image: 'assets/images/news/image 11.png'
            },
            {
                title: 'سهام عدالت متوفیان الکترونیکی',
                date: '9 آبان 1402',
                image: 'assets/images/news/image 12.png'
            },
            {
                title: 'سهام عدالت متوفیان الکترونیکی',
                date: '9 آبان 1402',
                image: 'assets/images/news/image 13.png'
            },
        ]
    },
    news: {
        title: 'آخرین اخبار',
        list: [
            {
                title: 'سهام عدالت متوفیان الکترونیکی',
                date: '9 آبان 1402',
                image: 'assets/images/news/image 8.png'
            },
            {
                title: 'سهام عدالت متوفیان الکترونیکی',
                date: '9 آبان 1402',
                image: 'assets/images/news/image 9.png'
            },
            {
                title: 'سهام عدالت متوفیان الکترونیکی',
                date: '9 آبان 1402',
                image: 'assets/images/news/image 10.png'
            },
        ]
    },
}
